/**
 * Generate a hash for an action by type and payload
 */
export const stagingAreaActionHashFn = <TItem = unknown>(item: TItem) => {
  return `${JSON.stringify(item)}`;
};

/**
 * Default function to parse items
 */
export const parseItemsFn = <TItem = unknown>(
  items: TItem[],
  hashFn: (item: TItem) => string = stagingAreaActionHashFn
) =>
  Array.from(
    items
      .reduce((acc, item) => {
        acc.set(hashFn(item), item);
        return acc;
      }, new Map<string, TItem>())
      .values()
  );
